import styles from 'styles/components/landing/melodyHeaderRule.scss';

const melodyHeaderRule = ({ slotDetails }) => {
  const { type, monetateId } = slotDetails;

  return (
    <hr className={styles.melodyRule} data-monetate-id={monetateId}>{type}</hr>
  );
};

export default melodyHeaderRule;
